import { useEffect, useState } from 'react';
import Model from './components/Model/Model';
import Detail from './components/Detail/Detail';
import { useLocation, useParams, useNavigate } from 'react-router-dom';
import styles from './ProductPage.module.scss';

import { getProduct } from '../../../api/product/getProduct';
import { getPart } from '../../../api/part/getPart';
import { Container } from '../../Container/Container';

const ProductPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { type } = location.state || 'model';
  const { id } = useParams();

  const [product, setProduct] = useState<any>(null);

  useEffect(() => {
    setProduct(null);
    if (!type) {
      getProduct(id as string)
        .then((res) => {
          setProduct(res);
        })
        .catch((err) => {
          if (err.status === 404) {
            getPart(id as string)
              .then((resPart) => {
                resPart.type = resPart.isExtra ? 'accessory' : 'part';
                setProduct(resPart);
              })
              .catch(() => {
                navigate('/not-found');
              });
          }
        });
    } else if (type === 'accessory' || type === 'part') {
      getPart(id as string)
        .then((res) => {
          res.type = res.isExtra ? 'accessory' : 'part';
          setProduct(res);
        })
        .catch(() => {
          navigate('/not-found');
        });
    } else {
      getProduct(id as string)
        .then((res) => {
          setProduct(res);
        })
        .catch(() => {
          navigate('/not-found');
        });
    }
  }, [id]);

  return (
    <div className={styles.ProductPage}>
      <Container>
        {product ? (
          product.type === 'accessory' || product.type === 'part' ? (
            <Detail {...product} />
          ) : (
            <Model {...product} />
          )
        ) : (
          'Загрузка...'
        )}
      </Container>
    </div>
  );
};

export default ProductPage;
